const shortenText = (text: string, length: number) => {
  if (text.length <= length) {
    return text;
  }
  let sub = text.substr(0, length);
  sub += '...';
  return sub;
};

const highlighterPostCodeType = {
  js: 'javascript',
  jsx: 'javascript',
  ts: 'typescript',
  tsx: 'typescript',
  css: 'css',
  scss: 'scss',
  graphql: 'graphql',
  json: 'json',
};

export { shortenText, highlighterPostCodeType };
